import { Cursor, PanelProps } from "@mcleod/components";
import { PanelOpenLayout } from "@mcleod/designer/src/ui/PanelOpenLayout";
import { HomePageEditor } from "./HomePageEditor";

export class PanelDraggableLayoutTree extends PanelOpenLayout {
  homeEditor: HomePageEditor;

  constructor(homeEditor: HomePageEditor, props: Partial<PanelProps>) {
    super({ ...props, minWidth: 240 });
    this.homeEditor = homeEditor;
    this.tree.borderWidth = 0;
  }

  override getSearchFilter() {
    return { widget: true, include_definitions: true };
  }


  displayLayouts() {
    super.displayLayouts();
    this.tree.getRootNode().recurseChildren(node => {
      if (node.getChildren().length === 0) {
        node.cursor = Cursor.GRAB;
        node.addMouseDownListener(_event => {
          let path = "";
          node.path.forEach(_node => path += _node.caption + "/");
          path = path.substring(0, path.length - 1);
          this.homeEditor.dragStart(path, node.data);
        });
      }
    });
  }
}
